import axios from 'axios';
import { clearLocalStorage, getJwtFromStorage } from '../../helpers/localstorage';
import { NOMNOM_URL } from '../../config';

export function get(url, data) {
  return axios
    .get(`${NOMNOM_URL}${url}`, {
      params: data,
      headers: {
        Authorization: `Bearer ${getJwtFromStorage()}`
      }
    })
    .then(handleResponse);
}

export function post(url, body) {
  return axios
    .post(`${NOMNOM_URL}${url}`, body, {
      headers: {
        Authorization: `Bearer ${getJwtFromStorage()}`
      }
    })
    .then(handleResponse);
}


export function postPagination(url, body) {
  return axios
    .post(`${NOMNOM_URL}${url}`, body, {
      headers: {
        Authorization: `Bearer ${getJwtFromStorage()}`,
        AccessControlAllowMethods: '*'
      }
    })
    .then((response) => {
      return { data: response.data, pagination: JSON.parse(response.headers['x-pagination']) };
    });
}

export function put(url, body) {
  return axios
    .put(`${NOMNOM_URL}${url}`, body, {
      headers: {
        Authorization: `Bearer ${getJwtFromStorage()}`
      }
    })
    .then(handleResponse);
}

export function del(url) {
  return axios
    .delete(`${NOMNOM_URL}${url}`, {
      headers: {
        Authorization: `Bearer ${getJwtFromStorage()}`,
        AccessControlAllowMethods: '*'
      }
    })
    .then(handleResponse);
}

const handleResponse = response => response.data;

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;

    // Validation errors: surface the response body so callers can read `.errors`.
    if (status === 400) {
      return { data: error.response.data };
    }

    // Unauthorized: an expired/invalid token on an authenticated call should send
    // the user back to login. Do NOT redirect when the failing call is the login
    // attempt itself, otherwise the page reloads before the caller can show its
    // own "failed to login" feedback.
    if (status === 401) {
      const isLoginRequest = error.config?.url?.endsWith('account');
      if (isLoginRequest) {
        return { data: null };
      }
      clearLocalStorage();
      window.location.href = '/login';
      return new Promise(() => { });
    }

    // Everything else (403/404/5xx/network) is a real failure: reject so callers'
    // `.catch` runs instead of being handed a fake success.
    return Promise.reject(error);
  }
);